import { useMemo } from 'react';
import { useExternalTheme } from '@deephaven/components';
import { getThemeDataFromPlugins } from "./PluginUtils.js";
/**
 * Use custom external or plugin themes.
 * @param pluginModules The plugin modules to get themes from when external
 * themes are disabled.
 */
export function useCustomThemes(pluginModules) {
  var _useExternalTheme = useExternalTheme(),
    isExternalThemeEnabled = _useExternalTheme.isEnabled,
    isExternalThemePending = _useExternalTheme.isPending,
    externalThemeData = _useExternalTheme.themeData;
  return useMemo(() => {
    // Get theme from parent window via `postMessage` apis
    if (isExternalThemeEnabled) {
      if (isExternalThemePending) {
        return null;
      }
      return externalThemeData ? [externalThemeData] : [];
    }

    // Get themes from plugins
    return pluginModules == null ? null : getThemeDataFromPlugins(pluginModules);
  }, [isExternalThemeEnabled, isExternalThemePending, externalThemeData, pluginModules]);
}
export default useCustomThemes;
//# sourceMappingURL=useCustomThemes.js.map